<template lang="pug">
window(title="Fits Images", :zGroup=1, :isOpen="module.showManager", :closeButton="true", @closebuttonclick="module.showManager = false")
  table.matrix
    thead
      tr
        th
          i.material-icons visibility
        th Name
        th &harr;
        th &varr;
        th
          i.material-icons tune
        th
          i.material-icons delete
    tbody
      tr(v-for="fitsImage in frameStore.fitsImages")
        td
          input(type="checkbox", v-model="fitsImage.show")
        td
          input(type="text", v-model="fitsImage.name")
        td {{ fitsImage.hdu.card('NAXIS1', 'number') }}
        td {{ fitsImage.hdu.card('NAXIS2', 'number') }}
        td
          input(type="checkbox", v-model="fitsImage.toneWindow")
        td
          button(@click="remove(fitsImage)") &times;
  form(ref="form")
    input(type="file", @change="fileSelect", multiple=true)
</template>

<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { FitsImageModule } from '@/modules/FitsImageModule';
import { FrameStore } from '@/modules/base';
import { FitsImage } from '@/modules/FitsImageModule/FitsImage';

@Component
export default class extends Vue {
  @Prop({ required: true })
  module!: FitsImageModule

  @Prop({ required: true })
  frameStore!: FrameStore<typeof FitsImageModule>

  remove(fitsImage: FitsImage) {
    const l = this.frameStore.fitsImages
    const i = l.indexOf(fitsImage)
    i >= 0 && l.splice(i, 1)
  }

  async fileSelect(e: Event) {
    e.preventDefault();
    const files: FileList = (e.target as any).files
    for (let i = 0; i < files.length; ++i) {
      await this.module.loadImage(files.item(i)!)
    }
    (this.$refs.form as HTMLFormElement).reset()
  }
}
</script>

<style lang="scss" scoped>
th {
  padding: 0 0.25em;
}

td {
  text-align: center;
}

input[type="text"] {
  box-shadow: none;
}
</style>
